import { useContext } from 'react';

import { CurrencyContext } from 'app/components/commons/Currency/CurrencyContext/CurrencyContext';

import styles from '../ExperienceDiscount.module.scss';

type RegularPriceProps = {
  originalPrice: number;
  discountedPrice: number;
  hasDiscount: boolean;
  label: string;
};

export const RegularPrice = ({
  originalPrice,
  discountedPrice,
  hasDiscount,
  label,
}: RegularPriceProps) => {
  const { currencyFormatter } = useContext(CurrencyContext);

  return (
    <div className={styles.priceRow}>
      <span className={styles.experienceDiscountedPrice}>
        {currencyFormatter(hasDiscount ? discountedPrice : originalPrice)}
      </span>
      {hasDiscount && (
        <span className={styles.experienceOriginalPrice}>
          {currencyFormatter(originalPrice)}
        </span>
      )}
      <span>{label}</span>
    </div>
  );
};
